var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstaIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 2.53516H7C4.23858 2.53516 2 4.77373 2 7.53516V17.5352C2 20.2966 4.23858 22.5352 7 22.5352H17C19.7614 22.5352 22 20.2966 22 17.5352V7.53516C22 4.77373 19.7614 2.53516 17 2.53516Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 11.9052C16.1234 12.7375 15.9812 13.5874 15.5937 14.3342C15.2062 15.081 14.5931 15.6866 13.8416 16.0649C13.0901 16.4431 12.2384 16.5748 11.4077 16.4411C10.5771 16.3075 9.80971 15.9153 9.21479 15.3204C8.61987 14.7255 8.22768 13.9581 8.09402 13.1274C7.96035 12.2968 8.09202 11.4451 8.47028 10.6936C8.84854 9.94207 9.45414 9.32895 10.2009 8.94146C10.9477 8.55396 11.7977 8.4118 12.63 8.53521C13.4789 8.6611 14.2648 9.05668 14.8716 9.66352C15.4785 10.2704 15.8741 11.0563 16 11.9052Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 7.03516H17.51",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstaIcon);
export default __webpack_public_path__ + "static/media/insta-icon.d7fb2f046bcf5fedef723c6e8e97a207.svg";
export { ForwardRef as ReactComponent };